import { Channel, DeliveryTypeCategory, PaymentType } from '@/features/orders/constants/app'
import CardFilledIcon from '@/features/ui/icons/components/CardFilledIcon'
import CardOnlineIcon from '@/features/ui/icons/components/CardOnlineIcon'
import CashIcon from '@/features/ui/icons/components/CashIcon'
import CounterIcon from '@/features/ui/icons/components/CounterIcon'
import DeliveryCarIcon from '@/features/ui/icons/components/DeliveryCarIcon'
import EshopIcon from '@/features/ui/icons/components/EshopIcon'
import KioskIcon from '@/features/ui/icons/components/KioskIcon'
import MealVoucherCardIcon from '@/features/ui/icons/components/MealVoucherCardIcon'
import MealVoucherIcon from '@/features/ui/icons/components/MealVoucherIcon'
import MenuIcon from '@/features/ui/icons/components/MenuIcon'
import QrIcon from '@/features/ui/icons/components/QrIcon'
import TakeawayIcon from '@/features/ui/icons/components/TakeawayIcon'
import TelephoneIcon from '@/features/ui/icons/components/TelephoneIcon'
import { FC } from 'react'
import { SvgProps } from 'react-native-svg'

export type IconComponent = FC<SvgProps>

export const deliveryTypeIconMap: Record<DeliveryTypeCategory, IconComponent> = {
    [DeliveryTypeCategory.Delivery]: DeliveryCarIcon,
    [DeliveryTypeCategory.EatIn]: MenuIcon,
    [DeliveryTypeCategory.Takeaway]: TakeawayIcon,
}

export const channelIconMap: Partial<Record<Channel, IconComponent>> = {
    [Channel.Kiosk]: KioskIcon,
    [Channel.QR]: QrIcon,
    [Channel.Phone]: TelephoneIcon,
    [Channel.Pos]: CounterIcon,
    [Channel.Tab]: CounterIcon,
    [Channel.Web]: EshopIcon,
}

export const paymentTypeIconMap: Partial<Record<PaymentType, IconComponent>> = {
    [PaymentType.Cash]: CashIcon,
    [PaymentType.CardOnsite]: CardFilledIcon,
    [PaymentType.Online]: CardOnlineIcon,
    [PaymentType.MealVoucherCard]: MealVoucherCardIcon,
    [PaymentType.MealVoucher]: MealVoucherIcon,
}
